import styled from "styled-components";

export const TooltipWrapper = styled.div`
  display: inline-block;
  position: relative;
  &:hover {
    cursor: pointer;
  }
`

export const Tooltip = styled.div`
  position: absolute;
  transform: translateX(-50%);
  z-index: 100;
  left: -252px;
  top: -70px;
  transform: translateX(0) translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 15px;
  gap: 10px;
  width: 307px;
  max-height: auto;
  background: #FFFFFF;
  border: 1px solid #F2F3F6;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #808080;
  a {
    color: ${({ theme }) => theme.color};
  }
`
